import { Component, OnInit } from '@angular/core';
import { ErrorAlertComponent } from '../../shared/error-alert/error-alert.component';
import { ReactiveFormsModule, FormsModule, NgForm} from '@angular/forms';
import { LoadingService } from '../../../services/general/loading.service';
import { CommonModule } from '@angular/common';
import { EmailSuppressedInterfaceRequest, DeleteEmailSuppressedInterfaceResponse } from '../../../interfaces/getsuppressed-email.interface';
import { SuppressedEmailService } from '../../../services/crc-consult/suppressed-email.service';
import { SuccessAlertComponent } from "../../shared/success-alert/success-alert.component";
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';


@Component({
  selector: 'app-deletesuppressed-email',
  standalone: true,
  imports: [
    ErrorAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SuccessAlertComponent,
    ConfirmationModalComponent
],
  templateUrl: './deletesuppressed-email.component.html',
  styleUrl: './deletesuppressed-email.component.css'
})
export class DeletesuppressedEmailComponent implements  OnInit{

  showAlertError : boolean = false
  showSuccesAlert : boolean = false
  messaggeErrorAlert = ''
  message1SuccesAlert = 'Eliminacion exitosa'
  message2SuccesAlert = ''
  emailRequest : EmailSuppressedInterfaceRequest = {
    email : ''
  }
  deleteSuppressedEmailResponse : DeleteEmailSuppressedInterfaceResponse = {
    response : ''
  }
  token: string = '';
  isModalVisible : boolean = false
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Eliminar email lista supresion ses',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private _loadingService : LoadingService,
    private _logsService : LogTackingService,
    private _SuppressedEmailService : SuppressedEmailService
  ){}

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') || '';
  }

  onSubmit(form : NgForm){
    this._loadingService.setLoading(true)
    this._SuppressedEmailService.deleteSuppressedEmails(this.token, this.emailRequest)
      .subscribe({
        next: (response: DeleteEmailSuppressedInterfaceResponse) => {
          this.message2SuccesAlert =response.response
          this.showSuccesAlert = true
          this.log_info.details = `Success: Usuario elimino email de la lista de supresion ${this.emailRequest.email}`
          this.createTrackingLog()
          this._loadingService.setLoading(false)
        },
        error: (error: any) => {
          this.messaggeErrorAlert = error.error.error
          this.log_info.details = `Error: ${this.messaggeErrorAlert}`
          this.showErrorComponent(form)
        }
      })
      this.isModalVisible = false;
  }
  cancel(form : NgForm){
    form.resetForm();
  }
  showErrorComponent(form : NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 5000);
  }
  
  onConfirm(){
    this.isModalVisible = true
  }

  onCancel() {
    this.isModalVisible = false;
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
